import { useState, useRef, useEffect } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook";
import { useLanguage } from "../../context/LanguageContext";
import { courseRegistry } from "../../courses/courseRegistry";
import MobileNavigation from "../Navigation/MobileNavigation";
import LanguageSelector from "../Navigation/LanguageSelector";
import { ReactComponent as HomeIcon } from "../../images/icons/HomeIcon.svg";
import { ReactComponent as CircleIcon } from "../../images/icons/CircleIcon.svg";
import { ReactComponent as ArrowIcon } from "../../images/icons/UpArrow.svg";
import { ReactComponent as LogoutIcon } from "../../images/icons/LogoutIcon.svg";
import { ReactComponent as MyAccount } from "../../images/icons/MyAccount.svg";
import logoGlobal from "../../images/logoGlobal.png";
import "./Navigation.css";


function CourseNavigation({ currentUser, onSignOut }) {
  const t = useTranslation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const location = useLocation();
  const [showSignOut, setShowSignOut] = useState(false);
  const signoutRef = useRef(null);
  const [showCoursesMenu, setShowCoursesMenu] = useState(false);
  const coursesMenuRef = useRef(null);

  const pathParts = location.pathname.split("/");
  const courseSlug = pathParts[2] ||localStorage.getItem("activeCourse") ||currentUser?.courseSlug ||"fundamentals";
  const courseConfig = courseRegistry[courseSlug];
  const tabs = courseConfig?.tabs || [];
  const coursePath = (path) => courseSlug ? `/course/${courseSlug}${path}` : "/";

  /**For remembering last active courseSlug so it will not fallbacks to fundamentals by default - button Home Icon part */
  useEffect(() => {
    if (courseSlug) {
      localStorage.setItem("activeCourse", courseSlug);
    }
  }, [courseSlug]);

  useEffect(() => { /*for close dropdown menu on click outside the menu*/
    const handleClickOutside = (e) => {
      if (signoutRef.current && !signoutRef.current.contains(e.target)) {
        setShowSignOut(false);}
      if (coursesMenuRef.current && !coursesMenuRef.current.contains(e.target)) {
        setShowCoursesMenu(false);}
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  //if (!courseConfig) return null;


  console.log("courseSlug:", courseSlug);
  console.log("courseConfig:", courseConfig); 

  return (
    <nav className={`navigation lang-${language}`}>
      <MobileNavigation 
        t={t} 
        menuItems={[...tabs.map(tab => ({label: t(tab.label), to: coursePath(tab.path)})),
          { label: "HOME",
            action: () => {
              const lastCourse = courseSlug || localStorage.getItem("activeCourse") || currentUser?.courseSlug || "fundamentals";
              navigate(`/course/${lastCourse}/mycourses`);}
          },
          { label: "MY ACCOUNT",
            to: coursePath("/account")
          },
          {
            label: "LOG OUT",
            action: onSignOut
          }
        ]}
      />

      <div className="nav-left">
        <NavLink  to={coursePath("/welcome")}>
          <img className="navigation__logo" src= {logoGlobal} alt="logo"/>
        </NavLink> 
      </div>

      <ul className="navigation__menu">
        {tabs.map(tab => (
          <li key={tab.path}>
            <NavLink to={coursePath(tab.path)}
              className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}> 
              {t(tab.label) } 
            </NavLink>
          </li>
        ))}

        {/* Global Courses dropdown tab */}
        <li className="nav-item-dropdown" ref={coursesMenuRef}>
          <button type="button" className={`nav-link nav-dropdown-trigger ${showCoursesMenu ? "open" : ""}`}
            onClick={() => setShowCoursesMenu((v) => !v)}> 
            {t("courses")}
            <ArrowIcon className={`nav-dropdown-arrow ${showCoursesMenu ? "open" : ""}`} />
          </button>
          {showCoursesMenu && (
            <ul className="nav-submenu courses">
              <li>
                <NavLink to={coursePath("/mycourses")} className="submenu-link" 
                  onClick={() => setShowCoursesMenu(false)}>{t("myCoursesNPackages")}
                </NavLink>
              </li>
              <li>
                <NavLink  to={"/courses"} className="submenu-link"
                  onClick={() => setShowCoursesMenu(false)}> {t("AllCourses")}
                </NavLink>
              </li>
              <li>
                <NavLink to={coursePath("/aboutususer")} className="submenu-link" 
                  onClick={() => setShowCoursesMenu(false)}> {t("aboutus")}
                </NavLink>
              </li>
            </ul>
          )}
        </li>

      </ul>

      <div className="navigation__actions">
        <button className="icon-button" onClick={() => {
          const lastCourse = courseSlug || localStorage.getItem("activeCourse") || 
          currentUser?.courseSlug || "fundamentals";

          navigate(`/course/${lastCourse}/mycourses`); }
        }>
          <HomeIcon className="nav-icon"/>
        </button>

        <div className="icon-with-arrow user-wrapper">
          <button className="user-avatar" onClick={()=>setShowSignOut(!showSignOut)}>
            <CircleIcon className="nav-icon"/>
            <span className="avatar-letter"> {currentUser?.name?.slice(0,1)} </span>
          </button>
          <ArrowIcon className={`nav-arrow ${showSignOut ? "open":""}`}/>
        </div>

        {showSignOut && (
          <ul className="nav-submenu userinfo" ref={signoutRef}>
            <NavLink to={coursePath("/account")} className="userinfo-link">
              <MyAccount className="userinfo-icon"/><span>{t("account")}</span>
            </NavLink>
            <li className="userinfo-link" onClick={onSignOut}>
              <LogoutIcon className="userinfo-icon"/><span>{t("logout")}</span>
            </li>
          </ul>
        )}

        <LanguageSelector />

      </div>
    </nav>
  );
}

export default CourseNavigation;